import {
  GET_ERAS_START,
  GET_ERAS_SUCCESS,
  GET_ERAS_ERROR,
  CREATE_ERA_START,
  CREATE_ERA_SUCCESS,
  CREATE_ERA_ERROR,
  DELETE_ERA_START,
  DELETE_ERA_SUCCESS,
  DELETE_ERA_ERROR,
  EDIT_ERA_START,
  EDIT_ERA_SUCCESS,
  EDIT_ERA_ERROR,
} from '../actions/era/era.actiontype';

export default function(state = { list: [] }, action) {
  switch (action.type) {
    case GET_ERAS_START:
      return {
        ...state,
        isFetching: true,
      };
    case GET_ERAS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload,
      };
    case GET_ERAS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case CREATE_ERA_START:
      return {
        ...state,
        isCreating: true,
      };
    case CREATE_ERA_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: [...state.list, action.payload],
      };
    case CREATE_ERA_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case EDIT_ERA_START:
      return {
        ...state,
        isCreating: true,
      };
    case EDIT_ERA_SUCCESS:
      return {
        ...state,
        isCreating: false,
        list: state.list.map(era => {
          if (era.id === action.payload.id) {
            return action.payload;
          }
          return era;
        }),
      };
    case EDIT_ERA_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case DELETE_ERA_START:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_ERA_SUCCESS:
      const newList = state.list.filter(era => era.id !== action.payload.id);
      return {
        ...state,
        isDeleting: false,
        list: newList,
      };
    case DELETE_ERA_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
